module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"close":"Close","open-original":"Open original","prev":"Previous","next":"Next"},"pt-BR":{"close":"Fechar","open-original":"Abrir original","prev":"Anterior","next":"Próxima"}}')
  delete Component.options._Ctor
}
